import { env } from '@fjuel/configs/env';
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      if (env.DEV) console.error('[Query Error]', error);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      if (env.DEV) console.error('[Mutation Error]', error);
    },
  }),
  defaultOptions: {
    queries: {
      retry: false,
    },
    mutations: {
      retry: false,
    },
  },
});
